import { render } from "./App.vue?vue&type=template&id=98e068c2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=98e068c2&lang=scss"

import exportComponent from "/var/www/run/data/www/vedo1.com.ua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__